// extracted by mini-css-extract-plugin
export default {"productGallery":"tO-z","inQuickShop":"uO-z"};